//
//
//
//
//
//
//
//
export default {
  name: 'demo-playground-page-cache-on',
  data: function data() {
    return {
      value: ''
    };
  }
};